// extracted by mini-css-extract-plugin
module.exports = {"ProjectExplorer":"ProjectExplorer_ProjectExplorer__1SNN5","ResizeHandle":"ProjectExplorer_ResizeHandle__2_NPo"};